/**
 * Loads precompiled css... import this just one time.
 * Try/Catch as this fails on server-side render
 */
try {
  // still needed...
  require('@adc/ui-core/lib/styles.css')
} catch (e) {} // eslint-disable-line no-empty

export default null
